'use strict';

var EPK = EPK || {};
EPK.Faq = EPK.Faq || {};

EPK.Faq.faqAnswer = function () {
	var answer,btnEl,faqNo,
	answerArea = document.querySelector('.faq-useful'),
	answerBtn = document.querySelectorAll('a.faqAnswer');
	if (!answerArea) return;
	if (answerBtn.length > 0) {
		for (var i = 0; i < answerBtn.length; i++) {
			
			answerBtn[i].addEventListener('click',function (el) {
				btnEl = el.currentTarget;
				if (!btnEl) return; 
				answer = btnEl.getAttribute('data-answer');
				faqNo = btnEl.getAttribute('data-faqno');

				if (!btnEl.classList.contains('disabled')) {
					for (var j = 0; j < answerBtn.length; j++) {
						answerBtn[j].classList.add('disabled');
					}
					if (answer && faqNo) {
						$.ajax({
							url:'/faq/answer',
							data:{
								'question':faqNo,
								'answer': answer,
							},
							type:'POST',
							dataType:'JSON',
							cache:false,
						}).done(function (data) {
							if (data == '1' || data == '2') {
								answerArea.style.display = 'none';
							}
						}).fail(function (xhr, textStatus, errorThrown) {
						});
					}
				}
			},false);
			
		}
/*		answerBtn.forEach(function (e) {
			e.addEventListener('click',function (el) {
				btnEl = el.currentTarget;
				if (!btnEl) return; 
				answer = btnEl.getAttribute('data-answer');
				faqNo = btnEl.getAttribute('data-faqno');

				if (!btnEl.classList.contains('disabled')) {
					for (var i = 0; i < answerBtn.length; i++) {
						answerBtn[i].classList.add('disabled');
					}
					if (answer && faqNo) {
						$.ajax({
							url:'/faq/answer',
							data:{
								'question':faqNo,
								'answer': answer,
							},
							type:'POST',
							dataType:'JSON',
							cache:false,
						}).done(function (data) {
							if (data == '1' || data == '2') {
								answerArea.style.display = 'none';
							}
						}).fail(function (xhr, textStatus, errorThrown) {
						});
					}
				}
			},false);
		});*/
	}
};

$(function () {
	EPK.Faq.faqAnswer();
})